import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC, PropsWithChildren } from 'react';

import { Call } from '@gem/call/CallStore/Call';
import { popupItemStyles } from '@gem/ui-kit';

import { CallMember } from '../CallMember/CallMember';

interface ICallMemberItemProps {
  call: Call;
  userId: string;
  onSelect?(): void;
  className?: string;
}

export const CallMemberItem: FC<PropsWithChildren<ICallMemberItemProps>> = observer((props) => {
  const classes = classNames(
    popupItemStyles.container,
    popupItemStyles.interactive,
    props.className
  );

  return (
    <CallMember
      call={props.call}
      userId={props.userId}
      onClick={props.onSelect}
      className={classes}
    >
      {props.children}
    </CallMember>
  );
});
